// Updated: 2026-08-04 18:22:00 CDT
// Purpose: Infer a character's likely gender without depending on retired voice providers.

export type Gender = 'male' | 'female' | 'unknown';

// Common names for gender detection
const MALE_NAMES = new Set([
  'JOHN', 'JAMES', 'ROBERT', 'MICHAEL', 'DAVID', 'WILLIAM', 'RICHARD', 'CHARLES', 'JOSEPH', 'THOMAS',
  'CHRISTOPHER', 'DANIEL', 'PAUL', 'MARK', 'DONALD', 'STEVEN', 'KENNETH', 'JOSHUA', 'KEVIN', 'BRIAN',
  'GEORGE', 'TIMOTHY', 'RONALD', 'JASON', 'EDWARD', 'JEFFREY', 'RYAN', 'JACOB', 'GARY', 'NICHOLAS',
  'ERIC', 'JONATHAN', 'STEPHEN', 'LARRY', 'JUSTIN', 'SCOTT', 'BRANDON', 'BENJAMIN', 'SAMUEL', 'GREGORY',
  'ALEXANDER', 'PATRICK', 'FRANK', 'RAYMOND', 'JACK', 'DENNIS', 'JERRY', 'TYLER', 'AARON', 'JOSE',
  'HENRY', 'ADAM', 'DOUGLAS', 'NATHAN', 'PETER', 'ZACHARY', 'KYLE', 'NOAH', 'ALAN', 'ETHAN',
  'JEREMY', 'LIONEL', 'ANGEL', 'WALTER', 'SEAN', 'HAROLD', 'JORDAN', 'LOGAN', 'ARTHUR', 'ROGER',
  'MARCUS', 'LUIS', 'WAYNE', 'ALBERT', 'MASON', 'ELIJAH', 'WAYNE', 'ROY', 'EUGENE', 'LOUIS',
  'PHILIP', 'BOBBY', 'CARL', 'FRED', 'HAROLD', 'JORDAN', 'JESSE', 'ARTHUR', 'LAWRENCE', 'SEAN', 'ELI'
]);

const FEMALE_NAMES = new Set([
  'MARY', 'PATRICIA', 'JENNIFER', 'LINDA', 'ELIZABETH', 'BARBARA', 'SUSAN', 'JESSICA', 'SARAH', 'KAREN',
  'NANCY', 'LISA', 'BETTY', 'HELEN', 'SANDRA', 'DONNA', 'CAROL', 'RUTH', 'SHARON', 'MICHELLE',
  'LAURA', 'SARAH', 'KIMBERLY', 'DEBORAH', 'DOROTHY', 'LISA', 'NANCY', 'KAREN', 'BETTY', 'HELEN',
  'SANDRA', 'DONNA', 'CAROL', 'RUTH', 'SHARON', 'MICHELLE', 'LAURA', 'SARAH', 'KIMBERLY', 'DEBORAH',
  'AMY', 'ANGELA', 'BRENDA', 'EMMA', 'OLIVIA', 'CYNTHIA', 'MARIE', 'JANET', 'CATHERINE', 'FRANCES',
  'CHRISTINE', 'SAMANTHA', 'DEBRA', 'RACHEL', 'CAROLYN', 'JANET', 'MARIA', 'HEATHER', 'DIANE', 'JULIE',
  'JOYCE', 'VIRGINIA', 'VICTORIA', 'KELLY', 'CHRISTINA', 'JOAN', 'EVELYN', 'JUDITH', 'ANDREA', 'HANNAH',
  'JACQUELINE', 'MARTHA', 'GLORIA', 'SARA', 'JANICE', 'JULIA', 'KATHRYN', 'LOUISE', 'RUBY', 'GRACE',
  'ALICE', 'CHARLOTTE', 'ARIA', 'LILY', 'SOPHIA', 'AVA', 'MIA', 'EMILY', 'ANNA', 'CLAIRE', 'MARA'
]);

export const detectGender = (name: string): Gender => {
  const normalizedName = name.toUpperCase();
  const cleanName = normalizedName.replace(/[^A-Z\s]/g, '').trim();
  const firstName = cleanName.split(' ')[0];
  
  if (MALE_NAMES.has(firstName)) return 'male';
  if (FEMALE_NAMES.has(firstName)) return 'female';
  
  // Check for title/role-based gender hints
  if (normalizedName.includes('MR.') || normalizedName.includes('FATHER') || normalizedName.includes('KING') || normalizedName.includes('LORD')) {
    return 'male';
  }
  if (normalizedName.includes('MRS.') || normalizedName.includes('MS.') || normalizedName.includes('MOTHER') || normalizedName.includes('QUEEN') || normalizedName.includes('LADY')) {
    return 'female';
  }
  
  return 'unknown';
};
